module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueMiniParcours_LRP_disabled.c4e4c607.png";